
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("42zNJ", function(module, exports) {

$parcel$export(module.exports, "createPayloads", () => $276e70905df67437$export$51b606e6d67c2231);
$parcel$export(module.exports, "createExperimentalMetricsPayload", () => $276e70905df67437$export$6410c9ddb2ab201);

var $4XKM3 = parcelRequire("4XKM3");

var $VSDnB = parcelRequire("VSDnB");

var $5DPhz = parcelRequire("5DPhz");

var $cMrpI = parcelRequire("cMrpI");

var $lANdF = parcelRequire("lANdF");

var $5gx4p = parcelRequire("5gx4p");

var $fe1wc = parcelRequire("fe1wc");

var $f38ba = parcelRequire("f38ba");

var $aOr3t = parcelRequire("aOr3t");

var $fq6gA = parcelRequire("fq6gA");

var $37gc9 = parcelRequire("37gc9");

var $jI6pi = parcelRequire("jI6pi");

var $bFU4G = parcelRequire("bFU4G");

var $7p8yR = parcelRequire("7p8yR");

var $ghWs7 = parcelRequire("ghWs7");

var $8aEFN = parcelRequire("8aEFN");

var $bdDDw = parcelRequire("bdDDw");

var $cPbc1 = parcelRequire("cPbc1");

var $g1eyV = parcelRequire("g1eyV");

var $2UVld = parcelRequire("2UVld");

var $5dlW7 = parcelRequire("5dlW7");

var $5qZqx = parcelRequire("5qZqx");

var $airf9 = parcelRequire("airf9");

var $gPk9X = parcelRequire("gPk9X");
function $276e70905df67437$var$getUfoNameOverride(interaction) {
    const { ufoName: ufoName, apdex: apdex } = interaction;
    try {
        const ufoNameOverrides = (0, $fe1wc.getUfoNameOverrides)();
        if (ufoNameOverrides != null) {
            const metricKey = apdex.length > 0 ? apdex[0].key : '';
            if (ufoNameOverrides[ufoName][metricKey]) return ufoNameOverrides[ufoName][metricKey];
        }
        return ufoName;
    } catch (e) {
        return ufoName;
    }
}
function $276e70905df67437$var$getEarliestLegacyStopTime(interaction, labelStack) {
    let earliestLegacyStopTime = null;
    interaction.apdex.forEach((a)=>{
        if (!a?.stopTime) return;
        if (!(0, $g1eyV.labelStackStartWith)(a.labelStack ?? [], labelStack)) return;
        if (a.stopTime > interaction.start && (earliestLegacyStopTime ?? a.stopTime) >= a.stopTime) earliestLegacyStopTime = a.stopTime;
    });
    return earliestLegacyStopTime;
}
function $276e70905df67437$var$getBm3EndTimeOrFallbackValue(interaction, labelStack = [], fallbackValue = interaction.end) {
    if (interaction.type === 'press') return fallbackValue;
    return $276e70905df67437$var$getEarliestLegacyStopTime(interaction, labelStack) ?? fallbackValue;
}
function $276e70905df67437$var$getPageVisibilityUpToTTI(interaction) {
    const { start: start } = interaction;
    const bm3EndTimeOrInteractionEndTime = $276e70905df67437$var$getBm3EndTimeOrFallbackValue(interaction);
    return (0, $37gc9.getPageVisibilityState)(start, bm3EndTimeOrInteractionEndTime);
}
function $276e70905df67437$var$getVisibilityStateFromPerformance(stop) {
    try {
        const results = performance.getEntriesByType('visibility-state');
        if (!results || results.length === 0) return null;
        return results.reduce((acc = null, { name: name, startTime: startTime })=>{
            if (startTime > stop) return acc;
            if (acc === null && name === null) return null;
            if (acc === null) return name;
            if (acc !== name) return 'mixed';
            return acc;
        }, null);
    } catch (e) {
        return null;
    }
}
function $276e70905df67437$var$getMoreAccuratePageVisibilityUpToTTI(interaction) {
    const old = $276e70905df67437$var$getPageVisibilityUpToTTI(interaction);
    const tti = $276e70905df67437$var$getEarliestLegacyStopTime(interaction, []);
    if (!tti) return old;
    const buffered = $276e70905df67437$var$getVisibilityStateFromPerformance(tti);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
}
function $276e70905df67437$var$getMoreAccuratePageVisibilityUpToTTAI(interaction) {
    const old = (0, $5dlW7.default)(interaction);
    const buffered = $276e70905df67437$var$getVisibilityStateFromPerformance(interaction.end);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
}
function $276e70905df67437$var$getResourceTimings(start, end) {
    return $ghWs7.getResourceTimings(start, end) ?? undefined;
}
function $276e70905df67437$var$getBundleEvalTimings(start) {
    return $lANdF.getBundleEvalTimings(start);
}
function $276e70905df67437$var$getSSRSuccess(type) {
    return type === 'page_load' ? $cPbc1.getSSRSuccess() : undefined;
}
function $276e70905df67437$var$getSSRFeatureFlags(type) {
    return type === 'page_load' ? $cPbc1.getSSRFeatureFlags() : undefined;
}
const $276e70905df67437$var$getLCP = (end)=>{
    return new Promise((resolve)=>{
        let observer;
        const timeout = setTimeout(()=>{
            observer?.disconnect();
            resolve(null);
        }, 200);
        const performanceObserverCallback = (list)=>{
            const entries = Array.from(list.getEntries());
            const lastEntry = entries.reduce((agg, entry)=>{
                // Use the latest LCP candidate before TTAI
                if (entry.startTime <= end && (agg === null || agg.startTime < entry.startTime)) return entry;
                return agg;
            }, null);
            clearTimeout(timeout);
            if (!lastEntry || lastEntry === null) resolve(null);
            else resolve(lastEntry.startTime);
        };
        observer = new PerformanceObserver(performanceObserverCallback);
        observer.observe({
            type: 'largest-contentful-paint',
            buffered: true
        });
    });
};
async function $276e70905df67437$var$getPaintMetrics(type, end) {
    if (type !== 'page_load') return {};
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    const lcp = await $276e70905df67437$var$getLCP(end);
    if (lcp) metrics['metric:lcp'] = Math.round(lcp);
    return metrics;
}
function $276e70905df67437$var$getTTAI(interaction) {
    const { start: start, end: end } = interaction;
    const pageVisibilityUpToTTAI = (0, $5dlW7.default)(interaction);
    return !interaction.abortReason && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
}
function $276e70905df67437$var$getNavigationMetrics(type) {
    if (type !== 'page_load') return {};
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return {};
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart),
        nextHopProtocol: navigation.nextHopProtocol
    };
    return {
        'metrics:navigation': metrics
    };
}
function $276e70905df67437$var$getPPSMetrics(interaction) {
    const { start: start, end: end } = interaction;
    const config = (0, $fe1wc.getConfig)();
    const interactionStatus = (0, $2UVld.default)(interaction);
    const pageVisibilityUpToTTAI = (0, $5dlW7.default)(interaction);
    const tti = interaction.apdex?.[0]?.stopTime;
    const ttai = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
    const PPSMetricsAtTTI = tti !== undefined ? (0, $5DPhz.getLighthouseMetrics)({
        start: start,
        stop: tti
    }) : null;
    const PPSMetricsAtTTAI = ttai !== undefined ? (0, $5DPhz.getLighthouseMetrics)({
        start: start,
        stop: interaction.end
    }) : null;
    if (config?.shouldCalculateLighthouseMetricsFromTTAI && PPSMetricsAtTTAI !== null) return PPSMetricsAtTTAI;
    if (PPSMetricsAtTTI !== null) return {
        ...PPSMetricsAtTTI,
        'metrics@ttai': PPSMetricsAtTTAI
    };
    return {};
}
function $276e70905df67437$var$getSSRProperties(type) {
    return {
        'ssr:success': $276e70905df67437$var$getSSRSuccess(type),
        'ssr:featureFlags': $276e70905df67437$var$getSSRFeatureFlags(type)
    };
}
function $276e70905df67437$var$getAssetsMetrics(interaction, SSRDoneTime) {
    try {
        const config = (0, $fe1wc.getConfig)();
        const { type: type } = interaction;
        const allowedTypes = [
            'page_load'
        ];
        const assetsConfig = config?.assetsConfig;
        if (!allowedTypes.includes(type) || !assetsConfig) // Skip if: type not allowed or assetsClassification isn't configured
        return {};
        const reporter = new (0, $cMrpI.CHRReporter)();
        const resourceTimings = (0, $8aEFN.filterResourceTimings)(interaction.start, interaction.end);
        const assets = reporter.get(resourceTimings, assetsConfig, SSRDoneTime);
        if (assets) // Only add assets in case it exists
        return {
            'event:assets': assets
        };
        return {};
    } catch (error) {
        // Skip CHR in case of error
        return {};
    }
}
function $276e70905df67437$var$getBrowserMetadata() {
    const data = {};
    const now = new Date();
    data['event:localHour'] = now.getHours(); // returns the hours for this date according to local time
    data['event:localDayOfWeek'] = now.getDay(); // Sunday - Saturday : 0 - 6
    data['event:localTimezoneOffset'] = now.getTimezoneOffset(); // A number representing the difference, in minutes, between the date as evaluated in the UTC time zone and as evaluated in the local time zone.
    if (navigator.userAgent != null) {
        const browser = (0, (/*@__PURE__*/$parcel$interopDefault($4XKM3))).getParser(navigator.userAgent);
        data['event:browser:name'] = browser.getBrowserName();
        data['event:browser:version'] = browser.getBrowserVersion();
    }
    if (navigator.hardwareConcurrency != null) data['event:cpus'] = navigator.hardwareConcurrency;
    if (navigator.deviceMemory != null) data['event:memory'] = navigator.deviceMemory;
    // eslint-disable-next-line compat/compat
    if (navigator.connection != null) {
        data['event:network:effectiveType'] = navigator.connection.effectiveType;
        data['event:network:rtt'] = navigator.connection.rtt;
        data['event:network:downlink'] = navigator.connection.downlink;
    }
    return data;
}
function $276e70905df67437$var$getTracingContextData(interaction) {
    const { trace: trace, start: start } = interaction;
    let tracingContextData = {};
    if (trace) tracingContextData = {
        'ufo:tracingContext': {
            'X-B3-TraceId': trace.traceId,
            'X-B3-SpanId': trace.spanId,
            // eslint-disable-next-line compat/compat
            browserTimeOrigin: +(performance.timeOrigin + start).toFixed(2)
        }
    };
    return tracingContextData;
}
function $276e70905df67437$var$optimizeCustomData(interaction) {
    const { customData: customData, legacyMetrics: legacyMetrics } = interaction;
    const customDataMap = customData.reduce((result, { labelStack: labelStack, data: data })=>{
        const label = (0, $g1eyV.stringifyLabelStackFully)(labelStack);
        const value = result.get(label)?.data ?? {};
        result.set(label, {
            labelStack: (0, $g1eyV.optimizeLabelStack)(labelStack, (0, $5qZqx.getReactUFOPayloadVersion)(interaction.type)),
            data: Object.assign(value, data)
        });
        return result;
    }, new Map());
    if (legacyMetrics) {
        const legacyMetricsFiltered = legacyMetrics.filter((item)=>item.type === 'PAGE_LOAD').reduce((result, currentValue)=>{
            for (const [key, value] of Object.entries(currentValue.custom || {})){
                const label = (0, $g1eyV.stringifyLabelStackFully)([]);
                const labelValue = result.get(label)?.data ?? {};
                result.set(label, {
                    labelStack: (0, $g1eyV.optimizeLabelStack)([], (0, $5qZqx.getReactUFOPayloadVersion)(interaction.type)),
                    data: Object.assign(labelValue, {
                        [key]: value
                    })
                });
            }
            return result;
        }, new Map());
        return [
            ...customDataMap.values(),
            ...legacyMetricsFiltered.values()
        ];
    }
    return [
        ...customDataMap.values()
    ];
}
function $276e70905df67437$var$optimizeReactProfilerTimings(reactProfilerTimings, interactionStart, reactUFOVersion) {
    const reactProfilerTimingsMap = reactProfilerTimings.reduce((result, { labelStack: labelStack, startTime: startTime, commitTime: commitTime, actualDuration: actualDuration, type: type })=>{
        if (labelStack && startTime >= interactionStart) {
            const label = (0, $g1eyV.stringifyLabelStackFully)(labelStack);
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            const timing = result.get(label) || {
                labelStack: (0, $g1eyV.optimizeLabelStack)(labelStack, reactUFOVersion),
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 0,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = start;
            if (end > timing.endTime) timing.endTime = end;
            if (type === 'mount') timing.mountCount += 1;
            if (type === 'update') timing.rerenderCount += 1;
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...reactProfilerTimingsMap.values()
    ];
}
function $276e70905df67437$var$optimizeRedirects(redirects, interactionStart) {
    let lastRedirectTime = interactionStart;
    const updatedRedirects = redirects.sort((a, b)=>a.time - b.time).reduce((result, redirect)=>{
        const { fromInteractionName: fromInteractionName, time: time } = redirect;
        if (lastRedirectTime >= interactionStart) result.push({
            labelStack: [
                {
                    n: fromInteractionName
                }
            ],
            startTime: Math.round(lastRedirectTime),
            endTime: Math.round(time)
        });
        lastRedirectTime = time;
        return result;
    }, []);
    return updatedRedirects;
}
function $276e70905df67437$var$optimizeHoldInfo(holdInfo, interactionStart, reactUFOVersion) {
    const holdInfoMap = holdInfo.reduce((result, hold)=>{
        const { labelStack: labelStack, name: name, start: start, end: end, ignoreOnSubmit: ignoreOnSubmit } = hold;
        if (labelStack && !ignoreOnSubmit && start >= interactionStart) {
            const label = (0, $g1eyV.stringifyLabelStackFully)([
                ...labelStack,
                {
                    name: name
                }
            ]);
            const startTime = Math.round(start);
            const endTime = Math.round(end);
            const timing = result.get(label) || {
                labelStack: (0, $g1eyV.optimizeLabelStack)([
                    ...labelStack,
                    {
                        name: name
                    }
                ], reactUFOVersion),
                startTime: startTime,
                endTime: endTime
            };
            if (startTime < timing.startTime) timing.startTime = startTime;
            if (endTime > timing.endTime) timing.endTime = endTime;
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...holdInfoMap.values()
    ];
}
function $276e70905df67437$var$optimizeSpans(spans, interactionStart, reactUFOVersion) {
    const updatedSpans = spans.reduce((result, span)=>{
        const { labelStack: labelStack, type: type, name: name, start: start, end: end } = span;
        if (labelStack && start >= interactionStart) result.push({
            labelStack: (0, $g1eyV.optimizeLabelStack)([
                ...labelStack,
                {
                    name: name
                }
            ], reactUFOVersion),
            startTime: Math.round(start),
            endTime: Math.round(end),
            type: type
        });
        return result;
    }, []);
    return updatedSpans;
}
function $276e70905df67437$var$optimizeRequestInfo(requestInfo, interactionStart, reactUFOVersion) {
    const updatedRequestInfo = requestInfo.reduce((result, reqInfo)=>{
        const { labelStack: labelStack, name: name, start: start, end: end, networkStart: networkStart, networkComplete: networkComplete } = reqInfo;
        const startTime = networkStart ?? start;
        const endTime = networkComplete ?? end;
        if (labelStack && start >= interactionStart && endTime) result.push({
            labelStack: (0, $g1eyV.optimizeLabelStack)([
                ...labelStack,
                {
                    name: name
                }
            ], reactUFOVersion),
            startTime: Math.round(startTime),
            endTime: Math.round(endTime)
        });
        return result;
    }, []);
    return updatedRequestInfo;
}
function $276e70905df67437$var$optimizeCustomTimings(customTimings, interactionStart) {
    return customTimings.reduce((result, item)=>{
        Object.keys(item.data).forEach((key)=>{
            if (item.data[key].startTime >= interactionStart) result.push({
                labelStack: [
                    {
                        n: key
                    }
                ],
                startTime: Math.round(item.data[key].startTime),
                endTime: Math.round(item.data[key].endTime)
            });
        });
        return result;
    }, []);
}
function $276e70905df67437$var$optimizeMarks(marks, reactUFOVersion) {
    return marks.map(({ labelStack: labelStack, time: time, ...others })=>({
            ...others,
            labelStack: labelStack && (0, $g1eyV.optimizeLabelStack)(labelStack, reactUFOVersion),
            time: Math.round(time)
        }));
}
function $276e70905df67437$var$optimizeApdex(apdex, reactUFOVersion) {
    return apdex.map(({ stopTime: stopTime, labelStack: labelStack, ...others })=>({
            ...others,
            stopTime: Math.round(stopTime),
            ...labelStack ? {
                labelStack: (0, $g1eyV.optimizeLabelStack)(labelStack, reactUFOVersion)
            } : {}
        }));
}
function $276e70905df67437$var$objectToArray(obj = {}) {
    return Object.keys(obj).reduce((result, key)=>{
        result.push({
            label: key,
            data: obj[key]
        });
        return result;
    }, []);
}
function $276e70905df67437$var$getBM3SubmetricsTimings(submetrics) {
    if (!submetrics) return null;
    const submetricsTimings = submetrics.filter((item)=>{
        return typeof item.stop === 'number' && !!item.key && typeof item.start === 'number';
    }).map((item)=>{
        let childSubmetrics;
        const newKey = `include/${item.key}`;
        if (item.submetrics) childSubmetrics = $276e70905df67437$var$getBM3SubmetricsTimings(item.submetrics);
        return {
            [newKey]: {
                endTime: item.stop - item.start,
                startTime: item.start
            },
            ...childSubmetrics ? childSubmetrics : {}
        };
    });
    return submetricsTimings;
}
function $276e70905df67437$var$getBm3TrackerTimings(interaction) {
    const interactionLegacyMetrics = interaction.legacyMetrics;
    if (!interactionLegacyMetrics) return {};
    const legacyMetrics = interactionLegacyMetrics.map((item)=>{
        return {
            key: item.key,
            startTime: item.start,
            stopTime: item.stop,
            type: item.config?.type,
            reactUFOName: item.config?.reactUFOName,
            fmp: item.marks?.['fmp'] || item.stop,
            source: 'bm3',
            timings: (0, $aOr3t.getBm3Timings)(item.marks, item.config.timings),
            submetrics: $276e70905df67437$var$getBM3SubmetricsTimings(item.submetrics),
            pageVisibleState: item.pageVisibleState
        };
    }).filter((item)=>!!item.type);
    return {
        legacyMetrics: legacyMetrics
    };
}
function $276e70905df67437$var$getPayloadSize(payload) {
    return Math.round(new TextEncoder().encode(JSON.stringify(payload)).length / 1024);
}
function $276e70905df67437$var$getStylesheetMetrics() {
    try {
        const stylesheets = Array.from(document.styleSheets);
        const stylesheetCount = stylesheets.length;
        const cssrules = Array.from(document.styleSheets).reduce((acc, item)=>{
            // Other domain stylesheets throw a SecurityError
            try {
                return acc + item.cssRules.length;
            } catch (e) {
                return acc;
            }
        }, 0);
        const styleElements = document.querySelectorAll('style').length;
        const styleProps = document.querySelectorAll('[style]');
        const styleDeclarations = Array.from(document.querySelectorAll('[style]')).reduce((acc, item)=>{
            try {
                if ('style' in item) return acc + item.style.length;
                else return acc;
            } catch (e) {
                return acc;
            }
        }, 0);
        return {
            'ufo:stylesheets': stylesheetCount,
            'ufo:styleElements': styleElements,
            'ufo:styleProps': styleProps.length,
            'ufo:styleDeclarations': styleDeclarations,
            'ufo:cssrules': cssrules
        };
    } catch (e) {
        return {};
    }
}
let $276e70905df67437$var$regularTTAI;
let $276e70905df67437$var$expTTAI;
function $276e70905df67437$var$getErrorCounts(interaction) {
    return {
        'ufo:errors:globalCount': (0, $fq6gA.getGlobalErrorCount)(),
        'ufo:errors:count': interaction.errors.length
    };
}
async function $276e70905df67437$var$createInteractionMetricsPayload(interaction, interactionId, experimental) {
    const interactionPayloadStart = performance.now();
    const config = (0, $fe1wc.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    const { end: end, start: start, ufoName: ufoName, knownSegments: knownSegments, rate: rate, type: type, abortReason: abortReason, routeName: routeName, featureFlags: featureFlags, previousInteractionName: previousInteractionName, isPreviousInteractionAborted: isPreviousInteractionAborted, abortedByInteractionName: abortedByInteractionName, responsiveness: responsiveness } = interaction;
    const pageVisibilityAtTTI = $276e70905df67437$var$getPageVisibilityUpToTTI(interaction);
    const pageVisibilityAtTTAI = (0, $5dlW7.default)(interaction);
    const segments = config.killswitchNestedSegments ? [] : knownSegments;
    const segmentTree = (0, $5qZqx.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? (0, $g1eyV.buildSegmentTree)(segments.map((segment)=>segment.labelStack)) : {};
    const isDetailedPayload = pageVisibilityAtTTAI === 'visible';
    const isPageLoad = type === 'page_load';
    const calculatePageVisibilityFromTheStartOfPageLoad = config.enableBetterPageVisibilityApi && isPageLoad;
    const moreAccuratePageVisibilityAtTTI = calculatePageVisibilityFromTheStartOfPageLoad ? $276e70905df67437$var$getMoreAccuratePageVisibilityUpToTTI(interaction) : null;
    const moreAccuratePageVisibilityAtTTAI = calculatePageVisibilityFromTheStartOfPageLoad ? $276e70905df67437$var$getMoreAccuratePageVisibilityUpToTTAI(interaction) : null;
    const labelStack = interaction.labelStack ? {
        labelStack: (0, $g1eyV.optimizeLabelStack)(interaction.labelStack, (0, $5qZqx.getReactUFOPayloadVersion)(interaction.type))
    } : {};
    // Page Load
    const getInitialPageLoadSSRMetrics = ()=>{
        if (!isPageLoad) return {};
        const config = (0, $fe1wc.getConfig)();
        const SSRDoneTimeValue = (0, $airf9.default)(config);
        const SSRDoneTime = SSRDoneTimeValue !== undefined ? {
            SSRDoneTime: Math.round(SSRDoneTimeValue)
        } : {};
        return {
            ...SSRDoneTime,
            isBM3ConfigSSRDoneAsFmp: interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp,
            isUFOConfigSSRDoneAsFmp: interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp || !!config?.ssr?.getSSRDoneTime
        };
    };
    const pageLoadInteractionMetrics = getInitialPageLoadSSRMetrics();
    // Detailed payload. Page visibility = visible
    const getDetailedInteractionMetrics = (resourceTimings)=>{
        if (experimental || window.__UFO_COMPACT_PAYLOAD__ || !isDetailedPayload) return {};
        const spans = [
            ...interaction.spans,
            ...(0, $bFU4G.interactionSpans)
        ];
        (0, $bFU4G.interactionSpans).length = 0;
        return {
            errors: interaction.errors.map(({ labelStack: labelStack, ...others })=>({
                    ...others,
                    labelStack: labelStack && (0, $g1eyV.optimizeLabelStack)(labelStack, (0, $5qZqx.getReactUFOPayloadVersion)(interaction.type))
                })),
            holdActive: [
                ...interaction.holdActive.values()
            ],
            redirects: $276e70905df67437$var$optimizeRedirects(interaction.redirects, start),
            holdInfo: $276e70905df67437$var$optimizeHoldInfo(experimental ? interaction.holdExpInfo : interaction.holdInfo, start, (0, $5qZqx.getReactUFOPayloadVersion)(interaction.type)),
            spans: $276e70905df67437$var$optimizeSpans(spans, start, (0, $5qZqx.getReactUFOPayloadVersion)(interaction.type)),
            requestInfo: $276e70905df67437$var$optimizeRequestInfo(interaction.requestInfo, start, (0, $5qZqx.getReactUFOPayloadVersion)(interaction.type)),
            customTimings: $276e70905df67437$var$optimizeCustomTimings(interaction.customTimings, start),
            bundleEvalTimings: $276e70905df67437$var$objectToArray($276e70905df67437$var$getBundleEvalTimings(start)),
            resourceTimings: $276e70905df67437$var$objectToArray(resourceTimings)
        };
    };
    // Page load & detailed payload
    const getPageLoadDetailedInteractionMetrics = ()=>{
        if (!isPageLoad || !isDetailedPayload) return {};
        const config = (0, $fe1wc.getConfig)();
        return {
            initialPageLoadExtraTimings: $276e70905df67437$var$objectToArray($jI6pi.getTimings()),
            SSRTimings: config?.ssr?.getSSRTimings ? config.ssr.getSSRTimings() : $276e70905df67437$var$objectToArray($cPbc1.getSSRTimings())
        };
    };
    if (experimental) $276e70905df67437$var$expTTAI = $276e70905df67437$var$getTTAI(interaction);
    else $276e70905df67437$var$regularTTAI = $276e70905df67437$var$getTTAI(interaction);
    const newUFOName = (0, $g1eyV.sanitizeUfoName)(ufoName);
    const resourceTimings = $276e70905df67437$var$getResourceTimings(start, end);
    const [vcMetrics, experimentalMetrics, paintMetrics] = await Promise.all([
        (0, $gPk9X.default)(interaction),
        experimental ? (0, $f38ba.getExperimentalVCMetrics)(interaction) : Promise.resolve(undefined),
        $276e70905df67437$var$getPaintMetrics(type, end)
    ]);
    const payload = {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: {
                // basic
                'event:hostname': window.location?.hostname || 'unknown',
                'event:product': config.product,
                'event:schema': '1.0.0',
                'event:sizeInKb': 0,
                'event:source': {
                    name: 'react-ufo/web',
                    version: (0, $5qZqx.getReactUFOPayloadVersion)(interaction.type)
                },
                'event:region': config.region || 'unknown',
                'experience:key': experimental ? 'custom.experimental-interaction-metrics' : 'custom.interaction-metrics',
                'experience:name': newUFOName,
                ...(0, $VSDnB.fg)('platform_ufo_report_cpu_usage') ? {
                    'event:cpu:usage': (0, $7p8yR.createPressureStateReport)(interaction.start, interaction.end)
                } : {},
                // root
                ...$276e70905df67437$var$getBrowserMetadata(),
                ...$276e70905df67437$var$getSSRProperties(type),
                ...$276e70905df67437$var$getAssetsMetrics(interaction, pageLoadInteractionMetrics?.SSRDoneTime),
                ...$276e70905df67437$var$getPPSMetrics(interaction),
                ...paintMetrics,
                ...$276e70905df67437$var$getNavigationMetrics(type),
                ...vcMetrics,
                ...experimentalMetrics,
                ...config.additionalPayloadData?.(interaction),
                ...$276e70905df67437$var$getTracingContextData(interaction),
                ...$276e70905df67437$var$getStylesheetMetrics(),
                ...$276e70905df67437$var$getErrorCounts(interaction),
                interactionMetrics: {
                    namePrefix: config.namePrefix || '',
                    segmentPrefix: config.segmentPrefix || '',
                    interactionId: interactionId,
                    pageVisibilityAtTTI: pageVisibilityAtTTI,
                    pageVisibilityAtTTAI: pageVisibilityAtTTAI,
                    experimental__pageVisibilityAtTTI: moreAccuratePageVisibilityAtTTI,
                    experimental__pageVisibilityAtTTAI: moreAccuratePageVisibilityAtTTAI,
                    rate: // raw interaction metrics
                    rate,
                    routeName: routeName,
                    type: type,
                    abortReason: abortReason,
                    featureFlags: featureFlags,
                    previousInteractionName: previousInteractionName,
                    isPreviousInteractionAborted: isPreviousInteractionAborted,
                    abortedByInteractionName: abortedByInteractionName,
                    // performance
                    apdex: $276e70905df67437$var$optimizeApdex(interaction.apdex, (0, $5qZqx.getReactUFOPayloadVersion)(interaction.type)),
                    end: Math.round(end),
                    start: Math.round(start),
                    segments: (0, $5qZqx.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? segmentTree : segments.map(({ labelStack: labelStack, ...others })=>({
                            ...others,
                            labelStack: (0, $g1eyV.optimizeLabelStack)(labelStack, (0, $5qZqx.getReactUFOPayloadVersion)(interaction.type))
                        })),
                    marks: $276e70905df67437$var$optimizeMarks(interaction.marks, (0, $5qZqx.getReactUFOPayloadVersion)(interaction.type)),
                    customData: $276e70905df67437$var$optimizeCustomData(interaction),
                    reactProfilerTimings: $276e70905df67437$var$optimizeReactProfilerTimings(interaction.reactProfilerTimings, start, (0, $5qZqx.getReactUFOPayloadVersion)(interaction.type)),
                    ...responsiveness ? {
                        responsiveness: responsiveness
                    } : {},
                    ...labelStack,
                    ...pageLoadInteractionMetrics,
                    ...getDetailedInteractionMetrics(resourceTimings),
                    ...getPageLoadDetailedInteractionMetrics(),
                    ...$276e70905df67437$var$getBm3TrackerTimings(interaction),
                    'metric:ttai': experimental ? $276e70905df67437$var$regularTTAI || $276e70905df67437$var$expTTAI : undefined,
                    'metric:experimental:ttai': $276e70905df67437$var$expTTAI
                },
                'ufo:payloadTime': (0, $bdDDw.roundEpsilon)(performance.now() - interactionPayloadStart)
            }
        }
    };
    if (experimental) {
        $276e70905df67437$var$regularTTAI = undefined;
        $276e70905df67437$var$expTTAI = undefined;
    }
    payload.attributes.properties['event:sizeInKb'] = $276e70905df67437$var$getPayloadSize(payload.attributes.properties);
    return payload;
}
async function $276e70905df67437$export$51b606e6d67c2231(interactionId, interaction) {
    const ufoNameOverride = $276e70905df67437$var$getUfoNameOverride(interaction);
    const modifiedInteraction = {
        ...interaction,
        ufoName: ufoNameOverride
    };
    const interactionMetricsPayload = await $276e70905df67437$var$createInteractionMetricsPayload(modifiedInteraction, interactionId);
    return [
        interactionMetricsPayload
    ];
}
async function $276e70905df67437$export$6410c9ddb2ab201(interactionId, interaction) {
    const config = (0, $fe1wc.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    const ufoName = (0, $g1eyV.sanitizeUfoName)(interaction.ufoName);
    const rate = (0, $fe1wc.getExperimentalInteractionRate)(ufoName, interaction.type);
    if (!(0, $5gx4p.default)(rate)) return null;
    const pageVisibilityState = (0, $37gc9.getPageVisibilityState)(interaction.start, interaction.end);
    if (pageVisibilityState !== 'visible') return null;
    const result = await $276e70905df67437$var$createInteractionMetricsPayload(interaction, interactionId, true);
    return result;
}

});
parcelRegister("cMrpI", function(module, exports) {

$parcel$export(module.exports, "CHRReporter", () => $e136c9247301423c$export$7d0d4cfb6455ffa5);

var $VSDnB = parcelRequire("VSDnB");

var $dLZPs = parcelRequire("dLZPs");
class $e136c9247301423c$export$783d6618ee601ba {
    add(asset) {
        const encodedSize = asset.encodedSize || 0;
        const type = (0, $dLZPs.calculateTransferType)(asset.name, asset.initiatorType, asset.duration, asset.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += encodedSize;
        this.sizeTotal += encodedSize;
    }
    static makePayload(summary) {
        const { size: size, bundlesCount: bundlesCount, sizeTotal: sizeTotal } = summary;
        const cachedSize = size[0, $dLZPs.MEMORY_KEY] + size[0, $dLZPs.DISK_KEY];
        const sizeRatio = (0, $dLZPs.round)(cachedSize / summary.sizeTotal);
        return {
            size: sizeTotal,
            chr: sizeRatio,
            count: bundlesCount
        };
    }
    constructor(){
        this.bundles = {
            [(0, $dLZPs.MEMORY_KEY)]: 0,
            [(0, $dLZPs.DISK_KEY)]: 0,
            [(0, $dLZPs.NETWORK_KEY)]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [(0, $dLZPs.MEMORY_KEY)]: 0,
            [(0, $dLZPs.DISK_KEY)]: 0,
            [(0, $dLZPs.NETWORK_KEY)]: 0
        };
        this.sizeTotal = 0;
    }
}
class $e136c9247301423c$export$7d0d4cfb6455ffa5 {
    get(resourceTimings, assetsConfig, SSRDoneTime) {
        try {
            if (resourceTimings === null) return null;
            resourceTimings.forEach((entry)=>{
                if (!(0, $dLZPs.checkIfTimingsAvailable)(entry)) return;
                const hasNanValues = (0, $VSDnB.fg)('platform_ufo_assets_check_for_nan') ? entry.encodedSize === undefined || entry.encodedSize === null : false;
                if (entry.encodedSize === entry.decodedSize || hasNanValues) // incorrectly reported or lack of size
                return;
                const type = (0, $dLZPs.getTypeOfRequest)(entry);
                if (!(assetsConfig.allowedTypes || this.defaultAllowedTypes).includes(type)) return;
                if (assetsConfig.classification.all) this.all.add(entry);
                if (assetsConfig.classification.allAtlassian({
                    entry: entry
                })) this.allAtlassian.add(entry);
                if (assetsConfig.classification.preloaded({
                    entry: entry,
                    SSRDoneTime: SSRDoneTime
                })) this.preloaded.add(entry);
            });
            if (this.all.bundlesCount === 0) return null;
            const CHRData = {
                all: $e136c9247301423c$export$783d6618ee601ba.makePayload(this.all),
                allAtlassian: $e136c9247301423c$export$783d6618ee601ba.makePayload(this.allAtlassian),
                preloaded: $e136c9247301423c$export$783d6618ee601ba.makePayload(this.preloaded)
            };
            return CHRData;
        } catch (error) {
            return null;
        }
    }
    constructor(){
        this.all = new $e136c9247301423c$export$783d6618ee601ba();
        this.allAtlassian = new $e136c9247301423c$export$783d6618ee601ba();
        this.preloaded = new $e136c9247301423c$export$783d6618ee601ba();
        this.defaultAllowedTypes = [
            'js'
        ];
    }
}

});
parcelRegister("dLZPs", function(module, exports) {

$parcel$export(module.exports, "MEMORY_KEY", () => $c588950b33a9d0ba$export$22f4983702ea2cc3);
$parcel$export(module.exports, "DISK_KEY", () => $c588950b33a9d0ba$export$d85e88075ae28804);
$parcel$export(module.exports, "NETWORK_KEY", () => $c588950b33a9d0ba$export$c46019be3f2161d7);
$parcel$export(module.exports, "calculateTransferType", () => $c588950b33a9d0ba$export$82deef6698791e4e);
$parcel$export(module.exports, "getTypeOfRequest", () => $c588950b33a9d0ba$export$d63396a1f85f70a0);
$parcel$export(module.exports, "checkIfTimingsAvailable", () => $c588950b33a9d0ba$export$c67eec4e6ad72694);
$parcel$export(module.exports, "round", () => $c588950b33a9d0ba$export$2077e0241d6afd3c);
const $c588950b33a9d0ba$export$5e1aa91d6932ddaa = [
    'script',
    'link',
    'other'
];
const $c588950b33a9d0ba$export$22f4983702ea2cc3 = 'mem';
const $c588950b33a9d0ba$export$d85e88075ae28804 = 'disk';
const $c588950b33a9d0ba$export$c46019be3f2161d7 = 'net';
function $c588950b33a9d0ba$export$82deef6698791e4e(name, type, duration, size) {
    if (!$c588950b33a9d0ba$export$5e1aa91d6932ddaa.includes(type) && !(type === 'other' && name.includes('.js'))) return null;
    if ((size === undefined || size === 0) && duration === 0) return $c588950b33a9d0ba$export$22f4983702ea2cc3;
    if (size === 0 && duration > 0) return $c588950b33a9d0ba$export$d85e88075ae28804;
    if (size === undefined) return null;
    return $c588950b33a9d0ba$export$c46019be3f2161d7;
}
function $c588950b33a9d0ba$export$d63396a1f85f70a0({ name: name, initiatorType: type }) {
    let category = 'other';
    const urlWithoutQuery = name.split('?')[0];
    switch(type){
        case 'script':
            category = 'js';
            break;
        case 'link':
            if (urlWithoutQuery.endsWith('.css')) category = 'css';
            if (urlWithoutQuery.endsWith('.js')) category = 'js';
            break;
        case 'img':
            category = 'image';
            break;
        case 'font':
            category = 'font';
            break;
        default:
            if (urlWithoutQuery.endsWith('.js')) category = 'js';
            else if (urlWithoutQuery.endsWith('.css')) category = 'css';
            else if (urlWithoutQuery.match(/\.(woff|woff2|ttf|otf)$/)) category = 'font';
            else if (urlWithoutQuery.match(/\.(png|jpg|jpeg|gif|svg)$/)) category = 'image';
            break;
    }
    return category;
}
function $c588950b33a9d0ba$export$c67eec4e6ad72694(entry) {
    if (entry.decodedSize === 0 && entry.encodedSize === 0 && entry.requestStart === 0 && entry.responseStart === 0) return false;
    return true;
}
function $c588950b33a9d0ba$export$2077e0241d6afd3c(n) {
    if (isNaN(n)) return 0;
    return Math.round(n * 10000) / 10000;
}

});


parcelRegister("lANdF", function(module, exports) {

$parcel$export(module.exports, "configure", () => $62d1dc5c906adae4$export$8d21e34596265fa2);
$parcel$export(module.exports, "getBundleEvalTimings", () => $62d1dc5c906adae4$export$2eda1519e91a4386);

var $bdDDw = parcelRequire("bdDDw");
let $62d1dc5c906adae4$var$config = null;
function $62d1dc5c906adae4$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
    $62d1dc5c906adae4$var$config = bundleEvalTimingConfiguration;
}
function $62d1dc5c906adae4$var$getPerformanceObject() {
    return (window ?? {}).performance;
}
function $62d1dc5c906adae4$export$2eda1519e91a4386(interactionStartTime) {
    if ($62d1dc5c906adae4$var$config == null) return {};
    const started = {};
    const timings = {};
    const cachedConfig = $62d1dc5c906adae4$var$config;
    const performance = $62d1dc5c906adae4$var$getPerformanceObject();
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: (0, $bdDDw.roundEpsilon)(started[name].startTime - interactionStartTime),
                duration: (0, $bdDDw.roundEpsilon)(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}

});
parcelRegister("bdDDw", function(module, exports) {

$parcel$export(module.exports, "roundEpsilon", () => $f25e0154c492e45e$export$56014375de40214b);
function $f25e0154c492e45e$export$56014375de40214b(num, places = 3) {
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}

});


parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("ghWs7", function(module, exports) {

$parcel$export(module.exports, "getResourceTimings", () => $76e1954f833c731a$export$9eebb59359c2e9e5);

var $VSDnB = parcelRequire("VSDnB");

var $fe1wc = parcelRequire("fe1wc");

var $bdDDw = parcelRequire("bdDDw");

var $3vLAR = parcelRequire("3vLAR");

var $8aEFN = parcelRequire("8aEFN");
const $76e1954f833c731a$var$alwaysCacheableTypes = [
    'script',
    'link'
];
const $76e1954f833c731a$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $76e1954f833c731a$var$CACHE_NETWORK = 'network';
const $76e1954f833c731a$var$CACHE_MEMORY = 'memory';
const $76e1954f833c731a$var$CACHE_DISK = 'disk';
function $76e1954f833c731a$var$isCacheableType(url, type) {
    if ($76e1954f833c731a$var$alwaysCacheableTypes.includes(type)) return true;
    if (type === 'other' && url.includes('.js')) return true;
    return false;
}
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
function $76e1954f833c731a$var$calculateTransferType(name, type, duration, size) {
    if (!$76e1954f833c731a$var$isCacheableType(name, type)) return $76e1954f833c731a$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $76e1954f833c731a$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $76e1954f833c731a$var$CACHE_DISK;
    if (size === undefined) return null;
    return $76e1954f833c731a$var$CACHE_NETWORK;
}
function $76e1954f833c731a$var$getWindowObject() {
    return typeof window !== 'undefined' && !!window ? window : undefined;
}
function $76e1954f833c731a$var$hasAccessToResourceSize(url, type, entry, hasTimingHeaders) {
    return !$76e1954f833c731a$var$isCacheableType(url, type) || url.includes('localhost') || !!$76e1954f833c731a$var$getWindowObject() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
}
function $76e1954f833c731a$var$getReportedInitiatorTypes(xhrEnabled) {
    const ufoConfig = (0, $fe1wc.getConfig)();
    if (!ufoConfig?.allowedResources) {
        if (xhrEnabled) return [
            'script',
            'link',
            'fetch',
            'other',
            'xmlhttprequest'
        ];
        return [
            'script',
            'link',
            'fetch',
            'other'
        ];
    }
    return ufoConfig.allowedResources;
}
function $76e1954f833c731a$var$evaluateAccessToResourceTimings(url, entry) {
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
}
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
function $76e1954f833c731a$var$getSizeObject(size) {
    return size !== undefined ? {
        size: size
    } : null;
}
function $76e1954f833c731a$var$getNetworkData(item, eventStart, hasTimingHeaders = $76e1954f833c731a$var$evaluateAccessToResourceTimings) {
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart, requestStart: requestStart, serverTime: serverTime, networkTime: networkTime, encodedSize: encodedSize, decodedSize: decodedSize } = item;
    const ttfb = (0, $bdDDw.roundEpsilon)(responseStart - eventStart);
    const requestStartRelative = (0, $bdDDw.roundEpsilon)(requestStart - eventStart);
    if (!$76e1954f833c731a$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($76e1954f833c731a$var$isCacheableType(name, initiatorType)) {
        const transferType = $76e1954f833c731a$var$calculateTransferType(name, initiatorType, duration, transferSize);
        return {
            ttfb: ttfb,
            transferType: transferType,
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: encodedSize,
            decodedSize: decodedSize,
            ...$76e1954f833c731a$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        serverTime: serverTime,
        networkTime: networkTime,
        requestStart: (0, $VSDnB.fg)('ufo_return_relative_request_start') ? requestStartRelative : requestStart,
        ...$76e1954f833c731a$var$getSizeObject(transferSize)
    };
}
function $76e1954f833c731a$export$9eebb59359c2e9e5(interactionStart, interactionEnd) {
    const resourceTiming = {};
    if (interactionStart === null) return resourceTiming;
    const resources = (0, $8aEFN.filterResourceTimings)(interactionStart, interactionEnd);
    if (!resources?.length) return resourceTiming;
    const { xhrFilter: xhrFilter, sanitiseEndpoints: sanitiseEndpoints, mapResources: mapResources, hasTimingHeaders: hasTimingHeaders } = (0, $3vLAR.getConfig)();
    const reportedInitiatorTypes = $76e1954f833c731a$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        if (initiatorType === 'other' && !name.includes('.js')) return;
        const url = $76e1954f833c731a$var$resourceTypes.includes(initiatorType) ? sanitiseEndpoints(name) : mapResources(name);
        if (!url) return;
        if (resourceTiming[url]) {
            resourceTiming[url].count = (resourceTiming[url].count || 1) + 1;
            return;
        }
        resourceTiming[url] = {
            startTime: (0, $bdDDw.roundEpsilon)(startTime - interactionStart),
            duration: (0, $bdDDw.roundEpsilon)(duration),
            workerStart: Math.max((0, $bdDDw.roundEpsilon)(workerStart - interactionStart), 0),
            fetchStart: Math.max((0, $bdDDw.roundEpsilon)(fetchStart - interactionStart), 0),
            type: initiatorType,
            ...$76e1954f833c731a$var$getNetworkData(item, interactionStart, hasTimingHeaders)
        };
    });
    return resourceTiming;
}

});
parcelRegister("3vLAR", function(module, exports) {

$parcel$export(module.exports, "configure", () => $0b58edb89023fc57$export$8d21e34596265fa2);
$parcel$export(module.exports, "getConfig", () => $0b58edb89023fc57$export$44487a86467333c3);

var $fe1wc = parcelRequire("fe1wc");
const $0b58edb89023fc57$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $0b58edb89023fc57$var$getAllowedParams() {
    const config = (0, $fe1wc.getConfig)();
    return config?.allowedResourcesParams || $0b58edb89023fc57$var$defaultAllowedParams;
}
function $0b58edb89023fc57$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $0b58edb89023fc57$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch (e) {
        return urlString;
    }
}
let $0b58edb89023fc57$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $0b58edb89023fc57$var$handleQueryParams(url);
    }
};
function $0b58edb89023fc57$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $0b58edb89023fc57$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $0b58edb89023fc57$var$config = newConfig;
}
function $0b58edb89023fc57$export$44487a86467333c3() {
    return $0b58edb89023fc57$var$config;
}

});

parcelRegister("8aEFN", function(module, exports) {

$parcel$export(module.exports, "resourceTimingBuffer", () => $33f750350a029cdd$export$bea963256235a63e);
$parcel$export(module.exports, "filterResourceTimings", () => $33f750350a029cdd$export$4138a729ef1db028);

var $bdDDw = parcelRequire("bdDDw");
const $33f750350a029cdd$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $33f750350a029cdd$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $33f750350a029cdd$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource (entry) {
        const duration = (0, $bdDDw.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
        const serverTime = totalBackendTimeEntry ? (0, $bdDDw.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $bdDDw.roundEpsilon)(entry.startTime),
            duration: (0, $bdDDw.roundEpsilon)(entry.duration),
            fetchStart: (0, $bdDDw.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $bdDDw.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $bdDDw.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $bdDDw.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $bdDDw.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $bdDDw.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start () {
        const performance = $33f750350a029cdd$var$getPerformanceObject();
        const PerformanceObserver = $33f750350a029cdd$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($33f750350a029cdd$export$bea963256235a63e.observer) return;
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $33f750350a029cdd$export$bea963256235a63e.timings = resources.map((resource)=>$33f750350a029cdd$export$bea963256235a63e.transformResource(resource));
        $33f750350a029cdd$export$bea963256235a63e.observer = new PerformanceObserver($33f750350a029cdd$export$bea963256235a63e.addTimings);
        $33f750350a029cdd$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop () {
        if ($33f750350a029cdd$export$bea963256235a63e.observer) {
            $33f750350a029cdd$export$bea963256235a63e.observer.disconnect();
            $33f750350a029cdd$export$bea963256235a63e.observer = null;
        }
        $33f750350a029cdd$export$bea963256235a63e.timings = [];
    },
    addTimings (list) {
        const entries = list.getEntries().map((entry)=>$33f750350a029cdd$export$bea963256235a63e.transformResource(entry));
        const overflow = $33f750350a029cdd$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $33f750350a029cdd$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $33f750350a029cdd$export$bea963256235a63e.maxSize;
            $33f750350a029cdd$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $33f750350a029cdd$export$bea963256235a63e.timings.push(...entries);
    }
};
function $33f750350a029cdd$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $33f750350a029cdd$export$4138a729ef1db028(startTime, endTime) {
    const performance = $33f750350a029cdd$var$getPerformanceObject();
    const PerformanceObserver = $33f750350a029cdd$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$33f750350a029cdd$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$33f750350a029cdd$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $33f750350a029cdd$export$bea963256235a63e.timings.filter((timing)=>$33f750350a029cdd$var$isValidTiming(timing, startTime, endTime));
}

});


parcelRegister("cPbc1", function(module, exports) {

$parcel$export(module.exports, "configure", () => $b6a66b7de4cc2962$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $b6a66b7de4cc2962$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $b6a66b7de4cc2962$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRDoneTime", () => $b6a66b7de4cc2962$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $b6a66b7de4cc2962$export$1c4a9b5e6e22393d);
const $b6a66b7de4cc2962$var$NESTED_METRIC_SEPARATOR = '/';
function $b6a66b7de4cc2962$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $b6a66b7de4cc2962$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
}
const $b6a66b7de4cc2962$var$SSR_PREFIX = 'ssr';
function $b6a66b7de4cc2962$var$mapKey(key) {
    if (key === 'total') return $b6a66b7de4cc2962$var$SSR_PREFIX;
    return `${$b6a66b7de4cc2962$var$SSR_PREFIX}${$b6a66b7de4cc2962$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $b6a66b7de4cc2962$var$config;
function $b6a66b7de4cc2962$export$8d21e34596265fa2(ssrConfig) {
    $b6a66b7de4cc2962$var$config = ssrConfig;
}
function $b6a66b7de4cc2962$export$bf7408e83532dcd0() {
    if (!$b6a66b7de4cc2962$var$config?.getTimings) return {};
    const timings = $b6a66b7de4cc2962$var$config.getTimings();
    if (!timings) return {};
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($b6a66b7de4cc2962$var$filterEntry(entry[1])) acc[$b6a66b7de4cc2962$var$mapKey(entry[0])] = $b6a66b7de4cc2962$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $b6a66b7de4cc2962$export$c7ad864055e75537() {
    return !!$b6a66b7de4cc2962$var$config?.getDoneMark();
}
function $b6a66b7de4cc2962$export$3def7672244bab0c() {
    return $b6a66b7de4cc2962$var$config?.getDoneMark() ?? undefined;
}
function $b6a66b7de4cc2962$export$1c4a9b5e6e22393d() {
    if (!$b6a66b7de4cc2962$var$config?.getFeatureFlags) return undefined;
    try {
        return $b6a66b7de4cc2962$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return undefined;
}

});

parcelRegister("g1eyV", function(module, exports) {

$parcel$export(module.exports, "sanitizeUfoName", () => $f62d411f1679e76e$export$e08487ea3ae92adb);
$parcel$export(module.exports, "isSegmentLabel", () => $f62d411f1679e76e$export$1adbaf5c2363e4ae);
$parcel$export(module.exports, "buildSegmentTree", () => $f62d411f1679e76e$export$1569bc0edeecbcd8);
$parcel$export(module.exports, "stringifyLabelStackFully", () => $f62d411f1679e76e$export$caeee352b541de1f);
$parcel$export(module.exports, "labelStackStartWith", () => $f62d411f1679e76e$export$1787b1cd413c7e2);
$parcel$export(module.exports, "optimizeLabelStack", () => $f62d411f1679e76e$export$a0cd72da07c76b4c);
function $f62d411f1679e76e$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}
function $f62d411f1679e76e$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $f62d411f1679e76e$export$1569bc0edeecbcd8(labelStacks) {
    const r = {
        n: 'segment-tree-root',
        c: {}
    };
    labelStacks.forEach((labelStack)=>{
        let currentNode = r;
        labelStack.forEach((label)=>{
            const name = label.name;
            const id = $f62d411f1679e76e$export$1adbaf5c2363e4ae(label) ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name
            };
            currentNode = currentNode.c[key];
        });
    });
    return {
        r: r
    };
}
function $f62d411f1679e76e$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        if ($f62d411f1679e76e$export$1adbaf5c2363e4ae(l)) return `${l.name}:${l.segmentId}`;
        return l.name;
    }).join('/');
}
function $f62d411f1679e76e$var$getLabelStackReference(labelStack) {
    return labelStack.map((l)=>$f62d411f1679e76e$export$1adbaf5c2363e4ae(l) ? l.segmentId : l.name).join('/');
}
function $f62d411f1679e76e$export$1787b1cd413c7e2(labelStack, startWith) {
    return $f62d411f1679e76e$export$caeee352b541de1f(labelStack).startsWith($f62d411f1679e76e$export$caeee352b541de1f(startWith));
}
function $f62d411f1679e76e$export$a0cd72da07c76b4c(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? $f62d411f1679e76e$var$getLabelStackReference(labelStack) : labelStack.map((ls)=>({
            n: ls.name,
            ...ls.segmentId ? {
                s: ls.segmentId
            } : {}
        }));
}

});

parcelRegister("2UVld", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0541d19d474dd21$export$2e2bcd8739ae039);
function $c0541d19d474dd21$var$getInteractionStatus(interaction) {
    let originalInteractionStatus = interaction.abortReason ? 'ABORTED' : 'SUCCEEDED';
    const hasErrors = interaction.errors.length > 0;
    originalInteractionStatus = hasErrors ? 'FAILED' : originalInteractionStatus;
    // `overrideStatus` is to be deprecated - https://product-fabric.atlassian.net/browse/AFO-3760
    return {
        originalInteractionStatus: originalInteractionStatus,
        overrideStatus: originalInteractionStatus
    };
}
var $c0541d19d474dd21$export$2e2bcd8739ae039 = $c0541d19d474dd21$var$getInteractionStatus;

});

parcelRegister("5dlW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $64204b66ea553673$export$2e2bcd8739ae039);

var $37gc9 = parcelRequire("37gc9");
function $64204b66ea553673$var$getPageVisibilityUpToTTAI(interaction) {
    const { start: start, end: end } = interaction;
    return (0, $37gc9.getPageVisibilityState)(start, end);
}
var $64204b66ea553673$export$2e2bcd8739ae039 = $64204b66ea553673$var$getPageVisibilityUpToTTAI;

});

parcelRegister("5qZqx", function(module, exports) {

$parcel$export(module.exports, "getReactUFOPayloadVersion", () => $c252917bfd08fd77$export$159168550e7449b8);
function $c252917bfd08fd77$export$159168550e7449b8(interactionType, isPostInteractionLog) {
    if (isPostInteractionLog) return '1.0.1';
    if (interactionType !== 'page_load' && interactionType !== 'transition') return '1.0.1';
    return '2.0.0';
}

});

parcelRegister("airf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fe9dbd0df24c491$export$2e2bcd8739ae039);

var $cPbc1 = parcelRequire("cPbc1");
function $7fe9dbd0df24c491$var$getSSRDoneTimeValue(config) {
    return config?.ssr?.getSSRDoneTime ? config?.ssr?.getSSRDoneTime() : $cPbc1.getSSRDoneTime();
}
var $7fe9dbd0df24c491$export$2e2bcd8739ae039 = $7fe9dbd0df24c491$var$getSSRDoneTimeValue;

});

parcelRegister("gPk9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $061cf1cd35486466$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $fe1wc = parcelRequire("fe1wc");

var $bFU4G = parcelRequire("bFU4G");

var $a0hd6 = parcelRequire("a0hd6");

var $2UVld = parcelRequire("2UVld");

var $5dlW7 = parcelRequire("5dlW7");

var $airf9 = parcelRequire("airf9");
async function $061cf1cd35486466$var$getVCMetrics(interaction) {
    const config = (0, $fe1wc.getConfig)();
    if (!config?.vc?.enabled) return {};
    if (interaction.type !== 'page_load' && interaction.type !== 'transition') return {};
    const interactionStatus = (0, $2UVld.default)(interaction);
    const pageVisibilityUpToTTAI = (0, $5dlW7.default)(interaction);
    const shouldReportVCMetrics = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && pageVisibilityUpToTTAI === 'visible';
    if (!shouldReportVCMetrics && (0, $VSDnB.fg)('platform_ufo_no_vc_on_aborted')) {
        (0, $a0hd6.getVCObserver)().stop(interaction.ufoName);
        return {};
    }
    const isSSREnabled = config?.ssr || config?.vc.ssrWhitelist?.includes(interaction.ufoName);
    const ssr = interaction.type === 'page_load' && isSSREnabled ? {
        ssr: (0, $airf9.default)(config)
    } : null;
    (0, $bFU4G.postInteractionLog).setVCObserverSSRConfig(ssr);
    const tti = interaction.apdex?.[0]?.stopTime;
    const prefix = 'ufo';
    const result = await (0, $a0hd6.getVCObserver)().getVCResult({
        start: interaction.start,
        stop: interaction.end,
        tti: tti,
        prefix: prefix,
        vc: interaction.vc,
        isEventAborted: interactionStatus.originalInteractionStatus !== 'SUCCEEDED',
        experienceKey: interaction.ufoName,
        interactionId: interaction.id,
        ...ssr
    });
    if (config.experimentalInteractionMetrics?.enabled) (0, $a0hd6.getVCObserver)().stop(interaction.ufoName);
    (0, $bFU4G.postInteractionLog).setLastInteractionFinishVCResult(result);
    if ((0, $VSDnB.fg)('platform_ufo_vc_enable_revisions_by_experience')) {
        const mostRecentVCRevision = (0, $fe1wc.getMostRecentVCRevision)(interaction.ufoName);
        const mostRecentVCRevisionPayload = result?.['ufo:vc:rev']?.find(({ revision: revision })=>revision === mostRecentVCRevision);
        if (!shouldReportVCMetrics || !mostRecentVCRevisionPayload?.clean) return result;
        return {
            ...result,
            'metric:vc90': mostRecentVCRevisionPayload['metric:vc90']
        };
    } else if (!(0, $fe1wc.isVCRevisionEnabled)('fy25.01')) {
        const ttvcV2Revision = result?.['ufo:vc:rev']?.find(({ revision: revision })=>revision === 'fy25.02');
        if (!ttvcV2Revision?.clean) return result;
        return {
            ...result,
            'metric:vc90': ttvcV2Revision['metric:vc90']
        };
    } else {
        const VC = result?.['metrics:vc'];
        if (!VC || !result?.[`${prefix}:vc:clean`]) return result;
        if (interactionStatus.originalInteractionStatus !== 'SUCCEEDED' || pageVisibilityUpToTTAI !== 'visible') return result;
        return {
            ...result,
            'metric:vc90': VC['90']
        };
    }
}
var $061cf1cd35486466$export$2e2bcd8739ae039 = $061cf1cd35486466$var$getVCMetrics;

});



//# sourceMappingURL=create-payloads.0a22c738.js.map
